import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getRequestCancelled } from '../../../api/purchaseRequest';
import PrimaryDataTable from '../../../components/PrimaryDataTable';
import { getRequestDataColumn } from '../components/pendingDataColumn';
import SearchRequest from '../components/SearchProduct';

const CancelledRequestScreen = () => {
  const apiRef = useGridApiRef();
  const columns = useMemo(() => getRequestDataColumn(apiRef), [apiRef]);

  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = (data) => {
    setRows([]);
    setLoader(true);

    getRequestCancelled({
      status: 3,
      search: data,
    }).then((res) => {
      let { code, result } = res.data.response;

      if (code === '00000') {
        setRows(result);
        setLoader(false);
      }
    });
  };

  const handleSearchSubmit = () => {
    loadData(search);
  };

  const handleSearchClear = () => {
    setSearch('');
    loadData();
  };

  return (
    <>
      <Row>
        <Col sm="12 mb-3">
          {/*  */}
          <SearchRequest
            search={search}
            handleSearch={(e) => setSearch(e.target.value)}
            handleSearchSubmit={handleSearchSubmit}
            handleSearchClear={handleSearchClear}
          />
        </Col>
        <Col>
          <PrimaryDataTable
            apiRef={apiRef}
            loading={loader}
            disableSelectionOnClick
            getRowId={(row) => row.pr_hdr_id}
            rows={rows}
            columns={columns}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  icon: false, // this hides the column initially
                },
              },
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default CancelledRequestScreen;
